<template>
    <b-form-group :label="variable.description">
        <b-form-select v-model="variable.value" :name="variable.name" :options="options"></b-form-select>
    </b-form-group>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: "Dropdown.vue",
    props: {
        variable: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapState({
            store: state => state.app.store,
        }),
        options() {
            const mapped = this.variable.options.map((option) => {
                let label = option.label;

                if (option.price > 0) {
                    label = label + ' (+' + this.store.currencySymbol + parseFloat(option.price).toFixed(2) + ')';
                }
                return {'value': option.id, 'text': label}
            })

            mapped.unshift({value: null, text: this.$t("details.form.select_placeholder"), disabled: true});

            return mapped;
        }
    }
}
</script>
